/**
 * PURPOSE:
 * Mostrar el encabezado del detalle público de una categoría de Karate.
 *
 * RESPONSIBILITIES:
 * - Permitir volver al listado.
 * - Exponer botón de recarga manual.
 * - Mostrar información compacta de categoría y última actualización.
 *
 * COLLABORATORS:
 * - CategoriasKarate.jsx
 * - karateBracketUtils.js
 *
 * ROUTE:
 * src/components/Software/Karate/Categorias/components/KarateBracketHeader.jsx
 */

import React from "react";
import {
  formatLastUpdated,
  getCategorySubtitle,
  getCategoryTitle,
} from "../utils/karateBracketUtils.js";

export default function KarateBracketHeader({
  category,
  lastUpdatedAt,
  loading,
  onBack,
  onRefresh,
}) {
  return (
    <div className="w-full max-w-full rounded-2xl border border-slate-200 bg-white p-3.5 shadow-sm sm:p-4">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div className="min-w-0">
          <button
            type="button"
            onClick={onBack}
            className="mb-3 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-black text-slate-700 shadow-sm transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm"
          >
            ← Volver a categorías
          </button>

          <div className="flex flex-wrap items-center gap-2">
            {category?.code && (
              <span className="rounded-full bg-blue-50 px-2.5 py-1 text-[11px] font-black uppercase tracking-wide text-blue-700 ring-1 ring-blue-100">
                {category.code}
              </span>
            )}
            {category?.tatami?.name && (
              <span className="rounded-full bg-slate-50 px-2.5 py-1 text-[11px] font-bold text-slate-600 ring-1 ring-slate-200">
                {category.tatami.name}
              </span>
            )}
          </div>

          <h2 className="mt-2 text-xl font-black leading-tight text-slate-900 sm:text-2xl">
            {getCategoryTitle(category)}
          </h2>
          <p className="mt-1.5 text-xs font-semibold text-slate-500 sm:text-sm">
            {getCategorySubtitle(category) || "Llave pública de Karate"}
          </p>
        </div>

        <div className="flex shrink-0 flex-col gap-1.5 sm:flex-row sm:items-center lg:flex-col lg:items-end">
          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-3.5 py-2.5 text-xs font-black text-white shadow-sm transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm"
          >
            {loading ? "Actualizando..." : "Recargar llave"}
          </button>
          <p className="text-[11px] font-bold text-slate-400 sm:text-right">
            Última actualización: {formatLastUpdated(lastUpdatedAt)}
          </p>
        </div>
      </div>
    </div>
  );
}
